<template>
  <section
    class="relative w-full overflow-hidden bg-cover bg-left bg-no-repeat"
    :style="bannerStyle"
  >
    <div class="container-wrap flex h-mobile-banner py-2 tablet:h-banner">
      <div class="flex w-full flex-col justify-center">
        <div>
          <h1 class="text-h1 banner-title mb-2">
            {{ t('title') }}
          </h1>
          <p class="banner-description is-mobile-hidden">
            {{ t('description') }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  const { t } = useI18n({ useScope: 'local' });
  const { blobDomain } = useWebsite();
  const { isCN } = useLanguage();

  const bannerStyle = computed((): string => {
    const imageUrl = isCN.value
      ? `${blobDomain.value}/wise-paas-marketplace/contact-us/contact-us_banner-01.webp`
      : `${blobDomain.value}/wise-paas-marketplace/contact-us/banner.webp`;

    return `background-image: url(${imageUrl})`;
  });
</script>

<i18n lang="json">
{
  "en-int": {
    "title": "Contact Us",
    "description": "Whether you're curious about solutions, a free trial, or technical issues—we're ready to answer any and all questions."
  },
  "en-jp": {
    "title": "Contact Us",
    "description": "Whether you're curious about solutions, a free trial, or technical issues—we're ready to answer any and all questions."
  },
  "en-tw": {
    "title": "Contact Us",
    "description": "Whether you're curious about solutions, a free trial, or technical issues—we're ready to answer any and all questions."
  },
  "en-kr": {
    "title": "Contact Us",
    "description": "Whether you're curious about solutions, a free trial, or technical issues—we're ready to answer any and all questions."
  },
  "en-americas": {
    "title": "Contact Us",
    "description": "Whether you're curious about solutions, a free trial, or technical issues—we're ready to answer any and all questions."
  },
  "en-asia-pacific": {
    "title": "Contact Us",
    "description": "Whether you're curious about solutions, a free trial, or technical issues—we're ready to answer any and all questions."
  },
  "en-emea": {
    "title": "Contact Us",
    "description": "Whether you're curious about solutions, a free trial, or technical issues—we're ready to answer any and all questions."
  },
  "ja-jp": {
    "title": "お問い合わせ",
    "description": "ソリューション、無料トライアル、または技術的な問題等、私たちはあらゆる質問に答える準備ができています。"
  },
  "zh-cn": {
    "title": "联系我们",
    "description": "无论您是对解决方案、免费试用还是技术问题有疑问,我们都能为您解答。"
  },
  "zh-tw": {
    "title": "聯繫我們",
    "description": "無論您是對解決方案、免費試用還是技術問題有疑問，我們都能為您解答。"
  }
}
</i18n>
